// extracted by mini-css-extract-plugin
module.exports = {"percentage":"styles_percentage__pF3Rv","progress":"styles_progress__2mcJD"};